import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import TagService from 'services/TagService';
import { useDispatch } from 'react-redux';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
    data: []
}


export const addTag = createAsyncThunk('tag/addTag', async (data, { rejectWithValue }) => {
	
	try {
		const response = await TagService.addTag(data)
		if (response.status) {
			console.log(response);
            
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})

export const getAllTag = createAsyncThunk('tag/getAllTag', async (data, { rejectWithValue }) => {
	
	try {
		const response = await TagService.getAllTag(data)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})

export const TagSlice = createSlice({
    name: 'tag',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(addTag.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(addTag.fulfilled, (state, action) => {
            state.loading = false
           // state.data.unshift(action.payload);
            state.message = "Tag Added"
        })
        .addCase(addTag.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getAllTag.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(getAllTag.fulfilled, (state, action) => {
            state.loading = false
            state.data = action.payload
            state.message = ''
        })
        .addCase(getAllTag.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
    }
});



export default TagSlice.reducer;